<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		label="Name"
		controlName="name"
		placeholder="Enter account name"
		[required]="true"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
